import {
  AccordionIcon as ChakraAccordionIcon,
  IconProps as ChakraIconProps,
  ComponentStyleConfig,
  StyleProps,
  useStyleConfig,
} from '@chakra-ui/react';

const AccordionIconStyles: ComponentStyleConfig = {
  baseStyle: {
    fontSize: '2xl',
  },
};
const AccordionIcon = (props: ChakraIconProps) => {
  const styles = useStyleConfig('AccordionIcon');

  // Can't use _css here as it breaks default functionality
  return <ChakraAccordionIcon {...(styles as StyleProps)} {...props} />;
};

export { AccordionIcon, AccordionIconStyles };
